import React from "react";
import { Link } from "react-router-dom";
import hatImg from "../../assets/images/chapeuzinho.png";
import characterIcon from "../../assets/images/icon-character.png";
import { unlockRouletteMusic } from "../roulette/audio";
import "./QueueRow.scss";

const formatBRL = (val) => {
  const n = parseFloat(val) || 0;
  return `R$ ${n.toFixed(2).replace(".", ",")}`;
};

const STATUS_SEQUENCE = ["neutral", "gold", "orange", "yellow", "green", "red"];

const QueueRow = ({
  queue,
  index = 0,
  isPopular = false,
  token,
  onJoin,
  registerPath = "/new-account",
}) => {
  const status =
    STATUS_SEQUENCE[Math.min(index, STATUS_SEQUENCE.length - 1)];
  const playersCount = String(queue.users.length).padStart(2, "0");

  const classes = [
    "queue-row",
    `queue-row--${status}`,
    isPopular && "queue-row--popular",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      <span className="queue-row__bar" aria-hidden="true" />

      <div className="queue-row__info">
        <span className="queue-row__value">{formatBRL(queue.value)}</span>
        {parseFloat(queue.rake) > 0 && (
          <span className="queue-row__rake">+ R$ {queue.rake}</span>
        )}
      </div>

      <span
        className={`queue-row__badge ${
          isPopular ? "" : "queue-row__badge--hidden"
        }`}
      >
        Em alta
      </span>

      <div className="queue-row__action">
        {token ? (
          <button
            type="button"
            className="queue-row__btn"
            onClick={() => {
              unlockRouletteMusic();
              onJoin?.(queue.id, parseFloat(queue.value) || 0);
            }}
          >
            Jogar
          </button>
        ) : (
          <Link to={registerPath} className="queue-row__btn">
            Jogar
          </Link>
        )}
      </div>

      <div className="queue-row__players" aria-label={`${queue.users.length} jogadores`}>
        <img src={characterIcon} alt="" className="queue-row__players-icon" />
        <span className="queue-row__players-count">{playersCount}</span>
      </div>

      {isPopular && (
        <span className="queue-row__hat" aria-hidden="true">
          <img src={hatImg} alt="" draggable={false} />
        </span>
      )}
    </div>
  );
};

export default QueueRow;
